import { rest } from 'msw';
import { clientUrl, clientsUrl } from '../utils/network/endpoints';

const apiMatcher = '*/api/v1';
export const handlers = [
  rest.get(`${apiMatcher}/admin/clients/*/products`, (req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      data: [
        {
          id: 2,
          name: "Learning",
          code: "learning",
          status: false,
          products: [],
        },
        {
          id: 1,
          name: "Advice",
          code: "advice",
          status: true,
          products: [
            {
              id: 1,
              name: "Basic Advice",
              product_category_id: 1,
              code: "basic_advice",
              status: false,
              elements: {
                advice_email_address: null,
              },
            },
            {
              id: 2,
              name: "Premier Advice",
              product_category_id: 1,
              code: "premier_advice",
              status: true,
              elements: [
                {
                  id: 2,
                  name: "Fact find questionnaire",
                  product_id: 2,
                  code: "ffq",
                  status: false,
                },
                {
                  id: 3,
                  name: "Booking",
                  product_id: 2,
                  code: "booking",
                  status: false,
                  location_id: "34342342343002",
                },
                {
                  id: 1,
                  name: "Introductory video and guides",
                  product_id: 2,
                  code: "introductory_video_and_guides",
                  status: true,
                },
              ],
            },
          ],
        },
      ],
      message: "",
    }),
  )),
];
